import {takeLeading, call, put, select} from "redux-saga/effects";

import * as UserActions from "@atg-global-shared/user/userActionTypes";
import {AuthSelectors} from "@atg-shared/auth";
import log, {serializeError} from "@atg-shared/log";
import {
    PersonalizationActions,
    PersonalizationApi,
} from "@atg-tillsammans-shared/personalization-data-access";

import * as AppActions from "./appConstants";

import type {AppAction} from "./appActions";
import type {LogoutInitiatedAction} from "@atg-global-shared/user/userActions";
import type {SagaIterator} from "redux-saga";

export function* initPersonalization(): SagaIterator {
    const isLoggedIn = yield select(AuthSelectors.isLoggedIn);

    if (!isLoggedIn) return;

    /**
     * Will be used to populate memberId if not available by personalization.
     *
     * TODO: Remove when backend support is added.
     */
    const authMemberId = yield select(AuthSelectors.getMemberId);

    try {
        const {ok, data} = yield call(PersonalizationApi.fetchPersonalizationSettings);
        if (ok) {
            yield put(
                PersonalizationActions.receivedPersonalizationSettings({
                    ...data,
                    memberId: data.memberId ?? authMemberId ?? undefined,
                }),
            );
        } else {
            log.error("Error fetching personalization", {error: serializeError(data)});
        }
    } catch (e: unknown) {
        log.error("Error fetching personalization", {error: serializeError(e)});
    }
}

export function* cleanupPersonalization(
    action: AppAction | LogoutInitiatedAction,
): SagaIterator {
    if (action.type === AppActions.APP_CONTEXT_LEAVE) {
        const preserveSettings = action.payload.options?.preservePersonalizationSettings;
        if (preserveSettings) return;
    }
    yield put(PersonalizationActions.resetPersonalizationSettings());
}

export function* appPersonalizationSaga(): SagaIterator {
    yield takeLeading(
        [
            UserActions.LOGIN_FINISHED,
            UserActions.RECEIVE_USER,
            AppActions.USER_ENTERED_TILLSAMMANS,
        ],
        initPersonalization,
    );
    yield takeLeading(
        [UserActions.LOGOUT_INITIATED, AppActions.APP_CONTEXT_LEAVE],
        cleanupPersonalization,
    );
}
